import React from 'react';
/*
import BlogHoriz from './BlogHoriz';
import BlogVert from './BlogVert';
import BlogVertPeq from './BlogVertPeq';
*/

function TextBlog() {
  return (

      <section className="blog">
              <div className="container">
                  <div className="row">
                      <div className="col-sm-12 col-12">
                          <h3>Read Blog</h3>
                      </div>
                  </div>
              </div>    
              <hr />
              <div className="container"> 
            
            <div className="row">
                <div className="col-lg-4 col-sm-12 col-12 box-1"  data-aos="fade-right" data-aos-delay="300">
                    <figure className="figure">
                        <a href="blog_single.html"><img src="images/blog-1.jpg" className="figure-img img-fluid" alt="blog" /></a>
                        <figcaption className="figure-caption">
                            <h2><a href="blog_single.html">Beautiful girl holding her camera in neck for a photo shoot</a></h2>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five</p>
                            <a href="blog_single.html" className="btn btn-success">+ more</a>
                        </figcaption>
                    </figure>
                </div>
                <div className="col-lg-8 col-sm-12 col-12"  data-aos="fade-left" data-aos-delay="300">
                    <div className="row">
                        <div className="col-sm-6 col-12 box-2">
                            <figure className="figure">
                                <a href="blog_single.html"><img src="images/blog-2.jpg" className="figure-img img-fluid" alt="blog" /></a>
                            </figure>
                        </div>
                        <div className="col-sm-6 col-12 box-3">
                            <h4><a href="blog_single.html">Girl working seriously on laptop in office hours</a></h4>
                            <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry. specimen book. It has survived not only five</h5>
                            <a href="blog_single.html" className="btn btn-success">+ more</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-12 box-4">
                            <figure className="figure">
                                <a href="blog_single.html"><img src="images/blog-3.jpg" className="figure-img img-fluid" alt="blog" /></a>
                            </figure>
                        </div>
                        <div className="col-sm-6 col-12 box-5">
                            <h4><a href="blog_single.html">Girl working seriously on laptop in office hours</a></h4>
                            <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry. specimen book. It has survived not only five</h5>
                            <a href="blog_single.html" className="btn btn-success">+ more</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-12 box-6">
                            <figure className="figure">
                                <a href="blog_single.html"><img src="images/blog-1.jpg" className="figure-img img-fluid" alt="blog" /></a>
                            </figure>
                        </div>
                        <div className="col-sm-6 col-12 box-7">
                            <h4><a href="blog_single.html">Girl working seriously on laptop in office hours</a></h4>
                            <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry. specimen book. It has survived not only five</h5>
                            <a href="blog_single.html" className="btn btn-success">+ more</a>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        </section>
    
    

  );
}

export default TextBlog;